import { createContext } from "react";


export const BalanceContext = createContext();
